var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlusCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.058,
    height: 18.057,
    viewBox: "0 0 18.058 18.057",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_13445",
    "data-name": "Group 13445",
    transform: "translate(-2390.67 18426.227)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8097",
    "data-name": "Path 8097",
    d: "M1304.7,543.787a7.534,7.534,0,1,1,7.534-7.534A7.55,7.55,0,0,1,1304.7,543.787Zm0-16.563a9.029,9.029,0,1,0,9.029,9.029A9.055,9.055,0,0,0,1304.7,527.224Z",
    transform: "translate(1095 -18953.451)",
    fill: "#786987"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8098",
    "data-name": "Path 8098",
    d: "M1308.311,535.342h-2.7c-1.98-.014-.172.005-1.823,0h-2.7a.911.911,0,0,0,0,1.823h7.223a.869.869,0,0,0,.911-.912A.887.887,0,0,0,1308.311,535.342Z",
    transform: "translate(1094.999 -18953.449)",
    fill: "#786987"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8099",
    "data-name": "Path 8099",
    d: "M1305.608,539.862v-2.7c.014-1.98-.005-.172,0-1.823v-2.7a.911.911,0,0,0-1.823,0v7.223a.868.868,0,0,0,.911.911A.887.887,0,0,0,1305.608,539.862Z",
    transform: "translate(1094.999 -18953.449)",
    fill: "#786987"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusCircle);
export default __webpack_public_path__ + "static/media/plus-circle.cec7a384355ea1f9f2a2f6bc5d883142.svg";
export { ForwardRef as ReactComponent };